import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  className?: string;
  i18n: I18N;
};
export const Reassurance = ({ className, i18n }: Props) => (
  <div className={classnames('flex flex-col items-center', className)}>
    <Icon name={ICONS.PADLOCK} width="3rem" />
    <div className="my-10 font-bold text-black">
      {i18n.booking.banking.reassurance.paymentReassuranceSentence}
    </div>
    <p className="text-center text-black">
      {i18n.booking.banking.reassurance.paymentReassuranceSentenceSubtitle}
    </p>
    <div className="flex justify-center">
      {i18n.booking.banking.reassurance.paymentReassuranceLogos.map((logo) => (
        <img alt="" className="m-10 block h-80" key={logo} src={logo} />
      ))}
    </div>
  </div>
);
